<template>
  <div class="contact min-h-50">
    <div class="border borderColordarkgray2 rounded overflow-hidden tracking-wider">
      <div class="service">
        <div class="contact-body px-4 md:px-10 py-6 md:py-8">
          <h4 class="mb-4 text-NotoSansRegular font-bold">業務合作洽談</h4>
          <h5 class="text-NotoSansRegular">若有任何業務上的洽談與合作，請以下列方式與我們聯繫：</h5>
          <div class="text-NotoSansRegular mt-4">
            <p>台北總公司：02-2578-2626</p>
            <p>總公司門市：台北市松山區八德路三段32號12樓</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  metaInfo () {
    return {
      title: '業務合作洽談',
      titleTemplate: null
    }
  },
  data () {
    return {
    }
  },
  components: {
  },
  computed: {
  },
  mounted () {
  },
  updated () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .contact-body {
    min-height: 26em;
    @media (max-width: 1025px) {
      min-height: 20em;
    }
    @media (max-width: 769px) {
      min-height: 18em;
    }
    @media (max-width: 577px) {
      min-height: 16em;
    }
  }
</style>
